module.exports = __webpack_public_path__ + "res/img_user_bg.7d4a9cd2614081f4c0a9743bc93ba124.png";